import { TableHead, styled, TableHeadProps } from "@mui/material";

const DarkTableHead = styled(TableHead)<TableHeadProps>(() => ({
  backgroundColor: "#425563",
  "th": {
    color: "#fff",
    fontWeight: "bold",
    lineHeight: "1rem",
    minWidth: "85px",
    textTransform: "uppercase",
  }
}));

export default DarkTableHead;